export default "__VITE_ASSET__CrQ_sxMA__"